import { NgModule, ModuleWithProviders, Injector, InjectionToken, Provider } from '@angular/core';
import { HttpClientModule, HttpHandler } from '@angular/common/http';

import { InternalHttpService } from './actions/http.mixin';

import { BgxHttpService, BgxInterceptorBehaviorService, IBgxHttpInterceptorConfig } from './interceptors/http.service';
import { BgxURLRegExpInterceptorMatcher } from './interceptors/url-regexp-interceptor-matcher.class';

export const HTTP_CONFIG: InjectionToken<IHttpConfig> = new InjectionToken<IHttpConfig>('HTTP_CONFIG');

export interface IHttpConfig {
  interceptors: IBgxHttpInterceptorConfig[];
}

export function httpFactory(handler: HttpHandler, injector: Injector, config: IHttpConfig): BgxHttpService {
  return new BgxHttpService(
    handler,
    new BgxInterceptorBehaviorService(injector, new BgxURLRegExpInterceptorMatcher(), config.interceptors),
  );
}

export const HTTP_INTERCEPTOR_PROVIDER: Provider = {
  provide: BgxHttpService,
  useFactory: httpFactory,
  deps: [HttpHandler, Injector, HTTP_CONFIG],
};

@NgModule({
  imports: [HttpClientModule],
  providers: [InternalHttpService],
})
export class BgxHttpModule {
  constructor(private _internalHttpService: InternalHttpService) {}

  static forRoot(config: IHttpConfig = { interceptors: [] }): ModuleWithProviders {
    return {
      ngModule: BgxHttpModule,
      providers: [
        {
          provide: HTTP_CONFIG,
          useValue: config,
        },
        HTTP_INTERCEPTOR_PROVIDER,
      ],
    };
  }
}
